import { CommonModule } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';
import { SeezService } from '../../../core/seez.service';

@Component({
    selector: 'ncg-seez-buy-button',
    standalone: true,
    template: `
        <a class="seezBuyOnline" [ngClass]="buttonClass" [attr.data-listing-id]="productId" [class.is-hidden]="isHidden">
            {{ textOverride || ('product_details.seez_buy' | translate) }}
        </a>
    `,
    imports: [CommonModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SeezBuyButtonComponent implements AfterViewInit, OnDestroy {
    private readonly unsubscribe = new Subject<void>();

    public isHidden = true;

    @Input()
    public productId?: string | null;

    @Input()
    public buttonClass?: string;

    @Input()
    public textOverride?: string;

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly seezService: SeezService
    ) {}

    public ngAfterViewInit(): void {
        this.seezService
            .getIsSeezLoaded()
            .pipe(takeUntil(this.unsubscribe))
            .subscribe((isSeezLoaded) => {
                setTimeout(() => {
                    if (isSeezLoaded && this.productId) {
                        this.isHidden = false;
                        this.seezService.initSeezButtons();
                        this.cd.markForCheck();
                    }
                });
            });
    }

    public ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}
